const FormActions = {
    START_LOAD: "form/start-load",
    LOADED: "form/loaded",
    LOAD_ERROR: "form/load-error",
};

export default FormActions;



// WEBPACK FOOTER //
// ./app/data/meta/FormActions.js